export const whatsAppModalVariations = {
  "chatOnWhatsApp": "Chat on WhatsApp",
  "aWhatsAppGroupHasBeen": "A WhatsApp group called",
  "privacyEnabled": "has been created for your event. However, due to your {codeBlock}, the admin has sent you an invitation to join the group.",
  "copyGroupNameText": "has been created on WhatsApp. Copy the group name or switch to WhatsApp to chat with the customer there.",
  "copyGroupNameBTNText": "Copy group name & open WhatsApp",
  "aGroupCalled": "A WhatsApp group called",
  "joinGroup": "Join group",
  "ifYouHaveMoreThenOne": "If you have more than one WhatsApp number, check the chats on your other numbers for the group invite"
}